<template>
  <div v-cloak class="animated fadeIn">
    <h1 class="mb-4">BlackList TED</h1>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header bg-transparent">
            <div class="col-lg-12">
              <div class="float-right">
                <button
                  @click="send"
                  class="btn btn-block btn-outline-primary"
                  type="button"
                >
                  <i class="fa fa-external-link pr-1"></i>
                  Confirm BlackListing
                </button>
              </div>

              <div class="input-group col-lg-3 float-right">
                <input
                  type="text"
                  class="form-control"
                  id="entity"
                  v-model="entity"
                  placeholder="Name of entity"
                />
                <span class="input-group-btn">
                  <button
                    @click="() => search()"
                    class="btn btn-block btn-outline-dark ml-1"
                    type="button"
                  >
                    <i class="fa fa-search pr-1"></i>
                    Search
                  </button>
                </span>
              </div>
              <div class="input-group col-lg-3 float-right">
                <input
                  type="text"
                  class="form-control"
                  id="counter"
                  v-model="counter"
                  placeholder="Name of Counterpart"
                />
              </div>
              <div class="row justify-content-between align-items-center">
                BlackList TED Candidates
              </div>
            </div>
            <hr />
          </div>
          <div class="card-body" v-if="isLoading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div class="card-body" v-if="searchResults.length">
            <table-component
              :columns="columns"
              :data="tableData"
              :filter-exclude-columns="columns"
            >
              <template slot="Merge" slot-scope="{ row }">
                <input
                  v-model="checkedRows"
                  type="checkbox"
                  :value="row.ted_id"
                />
              </template>

              <template slot="score" slot-scope="{ row }">
                <div>
                  {{ row.score ? row.score.toFixed(2) : "" }}
                </div>
              </template>

              <template slot="postal_score" slot-scope="{ row }">
                <div>
                  {{ row.postal_score ? row.postal_score.toFixed(2) : "" }}
                </div>
              </template>

              <template slot="name_score" slot-scope="{ row }">
                <div>
                  {{ row.name_score ? row.name_score.toFixed(2) : "" }}
                </div>
              </template>

              <template slot="street_score" slot-scope="{ row }">
                <div>
                  {{ row.street_score ? row.street_score.toFixed(2) : "" }}
                </div>
              </template>
            </table-component>
          </div>
          <div class="card-body" v-else-if="hasResult">
            <a> No result found </a>
          </div>
          <div class="card-body" v-else>
            <a> Please enter a valid name </a>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header bg-transparent">
        BlackList File
        <hr />
      </div>
      <div class="card-body">
        <span class="float-left">
          <button
            @click="
              $downloadFile({
                name: `blacklist.xlsx`,
                fileId: 99,
                url: `${BASE_URL}api/files/download/`,
              })
            "
            class="btn btn-outline-primary"
          >
            <i class="fa fa-download pr-1"></i>
            Download black list file
          </button>
        </span>
        <span class="float-right">
          <file-dragdrop
            title="Select a document file to upload"
            label="Upload"
            @upload="
              (files) =>
                $uploadFile({
                  fileId: 5,
                  file: files[0],
                  fileName: `black_list.xlsx`,
                })
            "
          >
          </file-dragdrop>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from "@/constants/config";
import { ActiveUser } from "@/services/user";


export default {
  name: "Blacklist",
  data() {
    return {
      BASE_URL,
      columns: [
        "counterpart_id",
        "counterpart_type",
        "counterpart_country_code",
        "counterpart_name",
        "entity_name",
        "counterpart_postal_address",
        "entity_address",
        "score",
        "name_score",
        "street_score",
        "postal_score",
        "Merge",
      ],
      searchResults: [],
      apiEndpointBase: `${BASE_URL}api/blacklist`,
      tableData: null,
      hasResult: false,
      isLoading: false,
      entity: "",
      counter: "",
      checkedRows: [],
      checked: { selected: [] },
    };
  },
  methods: {
    async search() {
      this.isLoading = true;
      let requestUrl = `${this.apiEndpointBase}/search/counter_entity/${this.counter}/${this.entity}`;
      if (this.entity.length === 0 && this.counter.length === 0) {
        requestUrl = this.apiEndpointBase;
      } else if (this.counter.length === 0) {
        requestUrl = `${this.apiEndpointBase}/search/entity/${this.entity}`;
      } else if (this.entity.length === 0) {
        requestUrl = `${this.apiEndpointBase}/search/counter/${this.counter}`;
      }
      const { data } = await this.$request({ url: requestUrl });
      this.tableData = data;
      this.searchResults = data;
      this.hasResult = true;
      this.isLoading = false;
    },
    async send() {
      if (this.checkedRows.length === 0) {
        alert("Please Select Rows");
        return;
      }
      const email = ActiveUser.get().email;
      const { res } = await this.$request({
        url: `${this.apiEndpointBase}/send`,
        method: "POST",
        body: {
          selection: this.checkedRows,
          email: email,
          counterpart: this.counter,
          entity: this.entity,
        },
      });
      if (res.status === 200 || res.status === 201) {
        alert("Added to Blacklist");
        this.checkedRows = [];
        this.search();
      } else {
        alert("Something went wrong");
      }
    },
  },
};
</script>

<style scoped></style>
